/**
 * Latvian Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const lv: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Panelis',
  'nav.funds': 'Fondi',
  'nav.investments': 'Ieguldījumi',
  'nav.investees': 'Ieguldījumu saņēmēji',
  'nav.esg': 'ESG Pārskats',
  'nav.compliance': 'Atbilstība',
  'nav.reports': 'Atskaites',
  'nav.settings': 'Iestatījumi',
  'nav.users': 'Lietotāji',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Rādītāji',
  'nav.taxonomy': 'ES Taksonomija',
  'nav.filings': 'Iesniegumi',
  'nav.calendar': 'Kalendārs',
  'nav.submit': 'Iesniegt datus',
  'nav.submissions': 'Mani iesniegumi',
  'nav.benchmarks': 'Etaloni',
  'nav.messages': 'Ziņojumi',
  'nav.portfolio': 'Portfelis',
  'nav.performance': 'Fondu rezultāti',
  'nav.esgSummary': 'ESG Kopsavilkums',
  'nav.pipeline': 'Konveijers',
  'nav.dueDiligence': 'Pienācīga pārbaude',
  'nav.impact': 'Ietekmes rādītāji',
  'nav.sdg': 'IAM Kartēšana',
  'nav.audit': 'Revīzijas izsekošana',
  'nav.snapshots': 'Datu momentuzņēmumi',
  'nav.knowledgeGraph': 'Zināšanu grafs',
  'nav.geographic': 'Ģeogrāfiskais',
  'nav.bi': 'BI Studija',
  'nav.ai': 'AI Palīgs',
  'nav.tasks': 'Uzdevumi',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Regulatīvais monitors',

  // Common Actions
  'action.create': 'Izveidot',
  'action.edit': 'Rediģēt',
  'action.delete': 'Dzēst',
  'action.save': 'Saglabāt',
  'action.cancel': 'Atcelt',
  'action.submit': 'Iesniegt',
  'action.approve': 'Apstiprināt',
  'action.reject': 'Noraidīt',
  'action.download': 'Lejupielādēt',
  'action.export': 'Eksportēt',
  'action.import': 'Importēt',
  'action.filter': 'Filtrēt',
  'action.search': 'Meklēt',
  'action.refresh': 'Atsvaidzināt',
  'action.close': 'Aizvērt',
  'action.back': 'Atpakaļ',
  'action.next': 'Nākamais',
  'action.previous': 'Iepriekšējais',
  'action.viewAll': 'Skatīt visu',
  'action.viewDetails': 'Skatīt detaļas',
  'action.generate': 'Ģenerēt',
  'action.signOut': 'Izrakstīties',
  'action.addNew': 'Pievienot jaunu',
  'action.invite': 'Uzaicināt',

  // Statuses
  'status.draft': 'Melnraksts',
  'status.submitted': 'Iesniegts',
  'status.validated': 'Validēts',
  'status.approved': 'Apstiprināts',
  'status.rejected': 'Noraidīts',
  'status.pending': 'Gaida',
  'status.inProgress': 'Procesā',
  'status.overdue': 'Nokavēts',
  'status.compliant': 'Atbilstošs',
  'status.filed': 'Iesniegts',
  'status.active': 'Aktīvs',
  'status.inactive': 'Neaktīvs',
  'status.closed': 'Slēgts',
  'status.fundraising': 'Līdzekļu piesaiste',
  'status.investing': 'Ieguldīšana',
  'status.harvesting': 'Ievākšana',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Portfeļa pārskats',
  'dashboard.complianceStatus': 'Atbilstības statuss',
  'dashboard.collectionProgress': 'Savākšanas progress',
  'dashboard.activityFeed': 'Aktivitāte',
  'dashboard.quickActions': 'Ātrās darbības',
  'dashboard.investmentPipeline': 'Ieguldījumu konveijers',
  'dashboard.totalFunds': 'Kopā fondi',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Aktīvie ieguldījumi',
  'dashboard.totalInvestees': 'Ieguldījumu saņēmēji',
  'dashboard.recentActivity': 'Nesenā aktivitāte',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Kopā apņemšanās',
  'lp.capitalCalled': 'Pieprasītais kapitāls',
  'lp.distributed': 'Sadalīts',
  'lp.netPosition': 'Neto pozīcija',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Fondu rezultāti',
  'lp.esgSummary': 'ESG Kopsavilkums',
  'lp.reportLibrary': 'Atskaišu bibliotēka',
  'lp.taxonomyAligned': 'Saskaņots ar taksonomiju',
  'lp.paiCoverage': 'PAI Pārklājums',
  'lp.portfolioPerformance': 'LP Portfeļa rezultāti',

  // Fund Labels
  'fund.name': 'Fonda nosaukums',
  'fund.code': 'Fonda kods',
  'fund.vintage': 'Dibināšanas gads',
  'fund.size': 'Fonda lielums',
  'fund.targetSize': 'Mērķa lielums',
  'fund.currency': 'Valūta',
  'fund.strategy': 'Stratēģija',
  'fund.status': 'Statuss',
  'fund.sfdrCategory': 'SFDR Kategorija',
  'fund.geographyFocus': 'Ģeogrāfiskais fokuss',
  'fund.sectorFocus': 'Nozares fokuss',

  // Form Labels
  'form.name': 'Nosaukums',
  'form.email': 'E-pasts',
  'form.country': 'Valsts',
  'form.amount': 'Summa',
  'form.currency': 'Valūta',
  'form.date': 'Datums',
  'form.description': 'Apraksts',
  'form.notes': 'Piezīmes',
  'form.type': 'Tips',
  'form.period': 'Periods',
  'form.year': 'Gads',
  'form.required': 'Obligāts',
  'form.optional': 'Neobligāts',

  // Table Headers
  'table.fund': 'Fonds',
  'table.commitment': 'Apņemšanās',
  'table.called': 'Pieprasīts',
  'table.distributed': 'Sadalīts',
  'table.tvpi': 'TVPI',
  'table.status': 'Statuss',
  'table.regulation': 'Regulējums',
  'table.filingType': 'Iesnieguma tips',
  'table.reportingPeriod': 'Periods',
  'table.createdAt': 'Izveidots',
  'table.actions': 'Darbības',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'ES Taksonomija',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Datu pilnīgums',
  'compliance.nextDeadline': 'Nākamais termiņš',

  // Reports
  'report.quarterly': 'Ceturkšņa atskaite',
  'report.annual': 'Gada atskaite',
  'report.paiStatement': 'PAI Paziņojums',
  'report.taxonomyReport': 'Taksonomijas atskaite',
  'report.generatedAt': 'Ģenerēts',
  'report.version': 'Versija',

  // General
  'general.loading': 'Ielādē...',
  'general.noData': 'Nav pieejamu datu',
  'general.error': 'Radās kļūda',
  'general.retry': 'Mēģināt vēlreiz',
  'general.total': 'Kopā',
  'general.page': 'Lapa',
  'general.of': 'no',
  'general.showing': 'Rāda',
  'general.results': 'rezultāti',
  'general.language': 'Valoda',
  'general.english': 'Angļu',
  'general.french': 'Franču',

  // Tour
  'tour.takeTour': 'Sakt apskati',
  'tour.skip': 'Izlaist',
  'tour.next': 'Talak',
  'tour.prev': 'Ieprieksejais',
  'tour.finish': 'Pabeigt',
};
